import React from 'react'
import { Item } from '../../../../common/snippets'
import { Box, Button, InputAdornment, TextField, Typography } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../../common/dropDownOA'
import SearchIcon from '@mui/icons-material/Search'
import BookingChrgTable from './BookingHamaliTable'
import { connect } from 'react-redux'
import { updateModal, updateAlertError } from '../../../../../store/common/common_action'
import { getBookingOperatorHamaliChargeList, getHamaliChrgListData, updateDeliveryChrg,updateBookingHamaliChargeInsertUpdate,updateBookingOperatorHamaliChargeInsertUpdate} from '../../../../../store/generalSetting/GSAction'
import * as mdt from '../../../../common/modaltypes'
import BookingChrgModal from './BookingHamaliModal'
import { useState } from 'react'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import { useEffect } from 'react'
import ConfirmModal from './ConfirmModal'
import { bookingTypeList, chargeTypeList, bookingHamaliTypeList } from '../../GSConstants'

const BookingHamali = (props) => {
  const {
    data: { common },
    updateModal,
    updateAlertError,
    getHamaliChrgListData,
    getBookingOperatorHamaliChargeList,
    updateBookingHamaliChargeInsertUpdate,
    updateBookingOperatorHamaliChargeInsertUpdate,
    updateDeliveryChrg,
  } = props
  const { loginData, showModal, modalType, cnsgnmntTypes } = common
  const [selConsignmentType, setSelConsignmentType] = useState({ ConsignmentSubTypeID: 0, SubType: 'All' })
  const [selBookingType, setSelBookingType] = useState({ id: 0, name: 'All' })
  const [consignmentTypeOpt, setConsignmentTypeOpt] = useState([])
  const [reportData, setReportData] = useState([])
  const [chargeType, setChargeType] = useState(chargeTypeList?.[0])
  const [hamaliType, setHamaliType] = useState(bookingHamaliTypeList?.[0])
  useEffect(() => {
    focusElemnt('Select_Consignment_Type')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      getBookingChrgList()
    }
  }, [loginData])
  useEffect(()=>{
    focusElemnt('Select_Consignment_Type')
  },[])
  const addBookingChrgModal = () => {
    const data = {
      isUpdate: false,
      headText: 'Success !!!',
      loginData: loginData,
      isEdit:false,
      ConsignmentTypeList: cnsgnmntTypes,
      ChargeTypeList: chargeTypeList,
      HamaliTypeList: bookingHamaliTypeList,
    }
    return (
      <BookingChrgModal
        data={data}
        reportData={reportData}
        getBookingChrgList={getBookingChrgList}
        updateModal={updateModal}
        updateAlertError={updateAlertError}
        updateDeliveryChrg={updateDeliveryChrg}
        getHamaliChrgListData={getHamaliChrgListData}
        updateBookingOperatorHamaliChargeInsertUpdate={updateBookingOperatorHamaliChargeInsertUpdate}
        getBookingOperatorHamaliChargeList={getBookingOperatorHamaliChargeList}
        updateBookingHamaliChargeInsertUpdate={updateBookingHamaliChargeInsertUpdate}
      />
    )
  }
  const updateBookingChrgModal = () => {
    const data = {
      isUpdate: true,
      headText: 'Updated !!!',
      loginData: loginData,
      isEdit:true,
      ConsignmentTypeList: consignmentTypeOpt,
      ChargeTypeList: chargeTypeList,
      HamaliTypeList: bookingHamaliTypeList,
    }
    return (
      <BookingChrgModal
        data={data}
        getBookingChrgList={getBookingChrgList}
        updateModal={updateModal}
        updateAlertError={updateAlertError}
        updateDeliveryChrg={updateDeliveryChrg}
        getHamaliChrgListData={getHamaliChrgListData}
        updateBookingOperatorHamaliChargeInsertUpdate={updateBookingOperatorHamaliChargeInsertUpdate}
        getBookingOperatorHamaliChargeList={getBookingOperatorHamaliChargeList}
        updateBookingHamaliChargeInsertUpdate={updateBookingHamaliChargeInsertUpdate}
        reportData={reportData}
      />
    )
  }
  const getBookingChrgList = () => {
    setReportData([])
    if (selConsignmentType === '' || selConsignmentType === ' ') {
      updateAlertError({ show: true, msg: 'Please Select Consignment Type', nextId: 'Select_Consignment_Type' })
    } else {
      if (hamaliType.id === 0) {
        const body = {
          CompanyID: loginData?.intCompanyID,
          ConsignmentTypeID: selBookingType?.id === 2 ? 0 : selConsignmentType?.ConsignmentSubTypeID,
          BookingType: selBookingType?.id,
          ChargeType:chargeType?.id
        }
        getHamaliChrgListData(body)
          .then((res) => {
            if (res.status === 'Success') {
              const updatedTable = res?.Data?.Table.map(val => ({ ...val, NOPFrom: val.RangeMin,NOPUpto:val.RangeMax,BookingType:val.BookingType,BookingUnitCharge:val.BookingHamaliCharge}));
              setReportData(updatedTable)
              setConsignmentTypeOpt(
                removeDuplicatesFromArray(res.Data.Table, 'ConsignmentID')
                  .map((obj) => ({ ConsignmentSubTypeID: obj.ConsignmentID, SubType: obj.ConsignmentType }))
                  .sort((a, b) => a.SubType.localeCompare(b.SubType))
              )
            } else {
              updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Consignment_Type' })
            }
          })
          .catch((err) => {
            console.log('Error:', err)
          }) 
      }else{
        const body = {
          CompanyID: loginData?.intCompanyID,
          ConsignmentTypeID: selBookingType?.id === 2 ? 0 : selConsignmentType?.ConsignmentSubTypeID,
          BookingType: selBookingType?.id,
          ChargeType:chargeType?.id
        }
        getBookingOperatorHamaliChargeList(body)
          .then((res) => {
            if (res.status === 'Success') {
              const updatedTable = res?.Data?.Table.map(val => ({ ...val, NOPFrom: val.RangeMin,NOPUpto:val.RangeMax,BookingType:val.BookingType,BookingUnitCharge:val.OptHamaliCharge}));
              setReportData(updatedTable)
              setConsignmentTypeOpt(
                removeDuplicatesFromArray(res.Data.Table, 'ConsignmentID')
                  .map((obj) => ({ ConsignmentSubTypeID: obj.ConsignmentID, SubType: obj.ConsignmentType }))
                  .sort((a, b) => a.SubType.localeCompare(b.SubType))
              )
            } else {
              updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Consignment_Type' })
            }
          })
          .catch((err) => {
            console.log('Error:', err)
          }) 
      }
    }
  }
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px' }}>
        <Box sx={{ display: 'flex' }} className="itemButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'Select_Consignment_Type'}
              label={'Select Consignment Type'}
              data={cnsgnmntTypes.length > 0 ? [{ ConsignmentSubTypeID: 0, SubType: 'All' }, ...cnsgnmntTypes] : []}
              defaultvalue={selConsignmentType?.SubType || selConsignmentType}
              onSelect={(val) => {
                setSelConsignmentType(val)
              }}
              idKey={`ConsignmentSubTypeID`}
              dataKey={`SubType`}
              minWidth="250px"
              prevId={``}
              nextId={'Select_Booking_Type'}
              disabled={selBookingType?.id === 2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }}>
            <DropDownOA
              id={'Select_Booking_Type'}
              label={'Select Booking Type'}
              data={bookingTypeList}
              defaultvalue={selBookingType?.name || selBookingType}
              onSelect={(val) => {
                setSelBookingType(val)
              }}
              idKey={`id`}
              dataKey={`name`}
              minWidth="250px"
              prevId={`Select_Consignment_Type`}
              nextId={'Select_Charge_Type'}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'Select_Charge_Type'}
              label={'Select Charge Type'}
              data={chargeTypeList}
              defaultvalue={chargeType.name}
              idKey={`id`}
              dataKey={`name`}
              minWidth="250px"
              onSelect={(val) => {
                setChargeType(val)
              }}
              prevId={`Select_Booking_Type`}
              nextId={'Hamali_Type'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }}>
            <DropDownOA
              id={'Hamali_Type'}
              label={'Hamali Type'}
              data={bookingHamaliTypeList}
              defaultvalue={hamaliType.name}
              idKey={`id`}
              dataKey={`name`}
              minWidth="250px"
              onSelect={(val) => {
                setHamaliType(val)
              }}
              prevId={`Select_Charge_Type`}
              nextId={'LoadBtn'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }} className="disabled-wrapper">
            <Button
              variant="contained"
              id="LoadBtn"
              sx={{ paddingY: '7px !important', height: '36px' }}
              className="btn btn-primary"
              onClick={getBookingChrgList}
              onKeyDown={(e) => navigation3(e, 'newAddBtn', 'Hamali_Type', () => {})}
            >
              Load
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="outlined"
              id="newAddBtn"
              sx={{ width: '100%' }}
              className="receiveitembtn"
              onClick={() => {
                updateModal(true, mdt.bookingChrgModal)
              }}
              onKeyDown={(e) => navigation3(e, 'editExisting', 'LoadBtn', () => {})}
            >
              + ADD NEW
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '6px' }} className="disabled-wrapper">
            <Button
              variant="outlined"
              sx={{ width: '100%' }}
              id="editExisting"
              className="receiveitembtn"
              onClick={() => {
                updateModal(true, mdt.updateBookingChrgModal)
              }}
              onKeyDown={(e) => navigation3(e, `filter-1`, 'newAddBtn', () => {})}
            >
              EDIT EXISTING
            </Button>
          </Item>
        </Box>
      </Box>
      <Box sx={{ marginTop: '15px' }}>
        <BookingChrgTable modalId={mdt.updateBookingChrgModal} updateModal={updateModal} reportData={reportData} />
      </Box>
      {showModal && mdt.bookingChrgModal === modalType ? addBookingChrgModal() : null}
      {showModal && mdt.updateBookingChrgModal === modalType ? updateBookingChrgModal() : null}
      {showModal && mdt.bookingChrgConfModal === modalType ? <ConfirmModal updateModal={updateModal} /> : null}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlertError, getHamaliChrgListData,getBookingOperatorHamaliChargeList, updateDeliveryChrg,updateBookingHamaliChargeInsertUpdate,updateBookingOperatorHamaliChargeInsertUpdate }
export default connect(mapStateToProps, mapDispatchToProps)(BookingHamali)
